module.exports={account_link_complete_message:"Liên kết tài khoản Nexon đã hoàn tất."};